import { Injectable } from '@angular/core';
import { ProductVariants } from '../models/product.schema';
import { ApiAuthService } from './api-auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProductVariantsService extends ApiAuthService {
  // private readonly productUrl = `${this.baseUrl}/products`;
  private readonly variantUrl = `${this.baseUrl}/products/variants`;

  findProductVariantWithSku(sku: string): Promise<ProductVariants> {
    return this.request(() =>
      this.http.get<ProductVariants>(`${this.variantUrl}/${sku}`).toPromise()
    );
  }
}
